const ID_NOTEBOOK_EDITOR_WORKER_SERVICE = 'notebookEditorWorkerService';
export { ID_NOTEBOOK_EDITOR_WORKER_SERVICE };
